import { OTP_FORM_FIELD } from "./authOtpConstants";
import {
  AUTH_AUTOFILL_NATIVE,
  AUTH_AUTOFILL_WEB,
  AUTH_INPUT_MODE
} from "./authAutofillHints";

export const otpCodeFormFields = [
  {
    name: OTP_FORM_FIELD.CODE,
    label: "auth_otp-page_code-label",
    type: "newText",
    required: true,
    fullWidth: true,
    inputMode: AUTH_INPUT_MODE.NUMERIC,
    maxLength: 6,
    autoComplete: AUTH_AUTOFILL_WEB.ONE_TIME_CODE,
    textContentType: AUTH_AUTOFILL_NATIVE.ONE_TIME_CODE,
    validations: {
      matchRegexp: /^\d{6}$/
    },
    validationErrors: {
      matchRegexp: "auth_otp-page_code-invalid",
      isDefaultRequiredValue: "This field is required"
    },
    value: "",
    wrapperClassName: "mb-4 md:mb-6",
    nativeStyles: { marginBottom: 24 }
  }
];
